import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// Newly added code starts
import Hidden from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
// Newly added code ends
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    linkList1GridItem?: GridItemProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    footerLinks?: InjectableCss;
}

export const footerContainerStyles: FooterContainerStyles = {
    widgetGridContainer: {
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        div[class^="GridOffset"] {
                             justify-content: space-between;
                            div[class^="GridItemStyle"] {
                                padding: 0px !important;
                                max-width: 166px;
                                margin-right: 24px;
                            }
                        }
                    `,
                    null,
                    null,
                ])};
        `,
    },
    linkList1GridItem: {
        width: [6, 6, 4, 3, 3],
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            > div > div > div:first-child {
                padding-bottom: 24px;
            }
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        // flex-basis: 23.1%;
                        // max-width: 23.1%;
                    `,
                    css`
                        // flex-basis: 23.1%;
                        // max-width: 23.1%;
                    `,
                ])};
        `,
    },
    linkList2GridItem: {
        width: [6, 6, 4, 3, 3],
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        // flex-basis: 23.1%;
                        // max-width: 23.1%;
                    `,
                    css`
                        // flex-basis: 23.1%;
                        // max-width: 23.1%;
                    `,
                ])};
        `,
    },
    linkList3GridItem: {
        width: [12, 12, 4, 3, 3],
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        // flex-basis: 23.1%;
                        // max-width: 23.1%;
                    `,
                    css`
                        // flex-basis: 23.1%;
                        // max-width: 23.1%;
                    `,
                ])};
        `,
    },
    linkList4GridItem: {
        width: [12, 12, 3, 3, 3],
        css: css`
            padding-top: 0;
            padding-bottom: 0;
            justify-content: center;
            aligne-items: center;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                    display:none;
                        padding-top: 24px;
                    `,
                    css`
                        // flex-basis: 23.1%;
                        // max-width: 23.1%;
                    `,
                    css`
                        // flex-basis: 23.1%;
                        // max-width: 23.1%;
                    `,
                ])};
        `,
    },
    footerLinks: {
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller};
            .list-wrapper {
                text-transform: capitalize;
                padding: 0;
                span {
                    color: ${COLORS.white};
                    padding-bottom: 8px;
                }
                &:hover {
                    span {
                        color: ${COLORS.white} !important;
                    }
                }
                > .links-wrapper:last-child span {
                    padding-bottom: 0;
                }
                > .links-wrapper {
                    max-height: 20px;
                    font-family: "Roboto";
                    margin-bottom: 8px;
                }
                > .links-wrapper a {
                }
                > .links-wrapper span {
                }
                .list-link span {
                    line-height: 20px;
                }
                .title-wrapper {
                    font-weight: ${TYPOGRAPHY.weight.bold};
                    color: ${COLORS.white};
                    max-height: 14px;
                    font-family: "Roboto Condensed";
                    margin-bottom: 12px;
                    text-transform: uppercase;
                    ${({ theme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            css`
                                margin-top: -3px;
                                margin-bottom: 16px;
                            `,
                            null,
                            null,
                        ])};
                }
                .title-wrapper h3 {
                    line-height: 14px;
                }
                .title-wrapper:has(h3) {
                    ${({ theme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            css`
                                margin-top: 0px !important;
                            `,
                            null,
                            null,
                        ])};
                }
                .title-wrapper span {
                    line-height: 14px;
                    max-height: 14px;
                }
            }
        `,
    },
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <GridContainer {...styles.widgetGridContainer}>
            <GridItem {...styles.linkList1GridItem}>
                <StyledWrapper {...styles.footerLinks}>
                    <Zone zoneName="LinkList1" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.linkList2GridItem}>
                <StyledWrapper {...styles.footerLinks}>
                    <Zone zoneName="LinkList2" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.linkList3GridItem}>
                <StyledWrapper {...styles.footerLinks}>
                    <Zone zoneName="LinkList3" contentId={id} />
                </StyledWrapper>
            </GridItem>
            <GridItem {...styles.linkList4GridItem}>
                <StyledWrapper {...styles.footerLinks}>
                    <Zone zoneName="LinkList4" contentId={id} />
                </StyledWrapper>
            </GridItem>
        </GridContainer>
    );
};

const NISfooterContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        allowedContexts: ["Footer"],
        displayName: "NISFooterContainer",
    },
};

export default NISfooterContainer;
